<template>
  <img alt="" src="../../assets/images/loader.gif" />
</template>

<style scoped>
@keyframes showEffect {
  0% {
    visibility: hidden;
  }
  100% {
    visibility: visible;
  }
}

img {
  animation-name: showEffect;
  animation-duration: 0.1s;
}
</style>
